import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SolutionOverview } from './components/SolutionOverview';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { OfferSection } from './components/OfferSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Pricing } from './components/Pricing';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchases } from './components/RecentPurchases';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1468583271333005');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen font-sans selection:bg-mint/30" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <SolutionOverview data-id="element-5" />
      <Tomos data-id="element-6" />
      <Bonuses data-id="element-7" />
      <OfferSection data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <Pricing data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
      <RecentPurchases data-id="element-14" />
    </div>;
}